(function () {
    'use strict';

    angular.module('SMART2').service('Common', [function () {
        this.convertServerDateTimeToNormalDateTime = function (input) {
            var IS_UNEXPECTED_DATE_INPUT = false;
            if ((typeof input).toLowerCase() === "string") {
                if (input.indexOf("Date") > -1) {
                    var a = (input + '').replace(new RegExp("/", "ig"), '');
                    a = a.split('+');
                    var b = eval('new ' + a[0] + (a.length > 1 ? ')' : ''));
                } else {
                    IS_UNEXPECTED_DATE_INPUT = true;
                }
            } else {
                IS_UNEXPECTED_DATE_INPUT = true;
            }
            if (IS_UNEXPECTED_DATE_INPUT) {
                if (isNaN(new Date(input))) {
                    return input;
                } else {
					if (typeof moment() != 'undefined') {
						var b = moment(input).toDate();
					}else{
						var b = new Date(input);
					}                  
                }
            }
            return b;
        };

        this.uniqueIDGenerator = function () {
            var d = new Date().getTime();
            var uniqueID = 'xxx2xxxpxxxoxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uniqueID;
        };

    }]);

    angular.module('SMART2').filter('minPrecisionHandler', ['$filter', function ($filter) {
        var postDecimalNumbers = 0;
        return function (input, decimals, maxDecimals, flag) {
            if (typeof RegionalSettingEnable !="undefined" && RegionalSettingEnable) {
                var currencySymbol = '';

                if (!isNaN(input)) {
                    var value = input;
                    try {
                        var temp = $("<input>");
                        var _decimals;
                        var decimalLength;
                        var tempValue;

                        var minPrecessionValue = decimals != undefined ? decimals : (MinPrecessionValue ? MinPrecessionValue : 2);

                        var maxPrecessionValue = maxDecimals != undefined ? maxDecimals : (MaxPrecessionValue ? MaxPrecessionValue : 4);

                        minPrecessionValue = parseInt(minPrecessionValue);

                        maxPrecessionValue = parseInt(maxPrecessionValue);

                        if (minPrecessionValue > maxPrecessionValue) {
                            maxPrecessionValue = minPrecessionValue;
                        }

                        tempValue = Math.round(value * Math.pow(10, maxPrecessionValue)) / Math.pow(10, maxPrecessionValue);

                        if (Number.isInteger(tempValue)) {
                            decimalLength = minPrecessionValue;
                        }
                        else if (Number.isNaN(tempValue)) {
                            throw "Value cannot change to number."
                        }
                        else {
                            decimalLength = tempValue.toString().split('.')[1].length;
                        }

                        if (decimalLength <= minPrecessionValue) {
                            _decimals = minPrecessionValue
                        }
                        else if (decimalLength >= maxPrecessionValue) {
                            _decimals = maxPrecessionValue;
                        }
                        else {
                            _decimals = decimalLength;
                        }

                        temp.autoNumeric('init', {
                            mDec: _decimals,
                            aPad: true
                        });
                        
                        temp.autoNumeric('set', tempValue); 
                        
                        var newValue;
                        if(cultureCode =="sv-se" || cultureCode =="pt-pt"){
                            newValue = temp.val().replace(/\./g, ' ');
                        }
                        else{
                            newValue = temp.val();
                        }

                        return currencySymbol + newValue;
                    }
                    catch (error) {
                        console.log(error);

                        console.log("error happend at numberformat filter. value : (" + value + ") minPrecessionValue : " + minPrecessionValue + " maxPrecessionValue : " + maxPrecessionValue);

                        return currencySymbol + value;
                    }
                }
                else {
                    return currencySymbol + input;
                }
            } else {
                if (input != undefined) {
                    if (input == 0)
                        return $filter('number')(0, decimals);
                    if (input != 0) {
                        postDecimalNumbers = ((input + "").split(".")[1] != undefined) ? (input + "").split(".")[1].length : 0;
                        if (postDecimalNumbers > maxDecimals) {
                            var fixed = Math.pow(10, maxDecimals);
                            var output = Math.round(input * fixed) / fixed;
                            var postDecimalOtp = ((output + "").split(".")[1] != undefined) ? (output + "").split(".")[1].length : 0;
                            if (postDecimalOtp < decimals)
                                return $filter('number')(output, decimals);
                            return $filter('addCommasToNumbers')(output);
                        } else if (postDecimalNumbers > decimals && postDecimalNumbers < maxDecimals)
                            return $filter('addCommasToNumbers')(input);
                         else if (postDecimalNumbers <= decimals)
                            return $filter('number')(input, decimals);
                    }
                    if (flag && flag == true && input != 0)
                        return '';
                    else
                        return input;
                }
                if (flag && flag == true)
                    return '';
                else
                    return 0;
            }
        }
    }]);
    angular.module('SMART2').service('SmartToast', [function () {
        this.show = function (config) {
            Materialize.toast(config.message, config.duration ? config.duration : 500);
        };
    }]);

    angular.module('SMART2').filter('addCommasToNumbers', ['$filter', function ($filter) {
        return function (input) {
            var postDecimalNumbers = ((input + "").split(".")[1] != undefined) ? (input + "").split(".")[1] : 0;
            var preDecimalNubmers =  ((input + "").split(".")[0] != undefined) ? (input + "").split(".")[0] : 0;
            preDecimalNubmers = $filter('number')(preDecimalNubmers);
            return  preDecimalNubmers + "." +  postDecimalNumbers;

        }
    }]);


    angular.module('SMART2').service('smartPaginate', ['smartTableUtils', '$translate', function (smartTableUtils, $translate) {
        var lineItems;
        var pageSize = 10;
        var filterState, sortState;
        var pagesCount = 0;

        var _setLineItems = function (tmpLineItems) {
            lineItems = tmpLineItems;
            if (lineItems instanceof Array) {
                pagesCount = Math.ceil(lineItems.length / pageSize) - 1;
            }
        };

        var _setPageSize = function(tmpPageSize) {
            pageSize = tmpPageSize;
            if (lineItems instanceof Array) {
                pagesCount = Math.ceil(lineItems.length / pageSize) - 1;
            }
        };

        var _getLineItems = function (offset, limit, smartTableAPI) {
            if (lineItems instanceof Array) {
                if (smartTableAPI) {
                    var tmpLineItems = smartTableUtils.extractSmartTableData(lineItems, smartTableAPI.saveState.save().filters, smartTableAPI.saveState.save().sort, smartTableAPI.options.enableTreeView, smartTableAPI.options.showTreeView, offset, limit, smartTableAPI.options.useExternalPagination).data;
                    smartTableAPI.core.pagination.setDataLength(tmpLineItems.length);
                    pagesCount = Math.ceil(tmpLineItems.length / pageSize) - 1;
                    return tmpLineItems.slice(offset, limit);
                }
                pagesCount = Math.ceil(lineItems.length / limit) - 1;
                return lineItems.slice(offset, limit);
            }
            return [];
        };

        var _getAllLineItems = function () {
            return lineItems;
        };

        var _getLineItemsCount = function () {
            return lineItems instanceof Array ? lineItems.length : 0;
        };

        var _getLineItemsPagesCount = function () {
            return pagesCount; 
        };
        
        return {
            externalPaginationThreshold: 300,
            setLineItems: _setLineItems,
            setPageSize: _setPageSize,
            getLineItems: _getLineItems,
            getAllLineItems: _getAllLineItems,
            getLineItemsCount: _getLineItemsCount,
            getLineItemsPagesCount: _getLineItemsPagesCount
        }
    }]);
})();
